export class DialogIdentifier {
    prefixNodeId: string;
}


